<template>
    <div class="returnTo">
      <img :src="src" alt="" @click="back">
    </div>
</template>
<script>
    export default{
        data(){
            return {
              src:require('@/assets/return.png')
            }
        },
        props:{
            url:''
        },
        methods:{
           back(){
               this.$router.push(this.url)
           }
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
.returnTo{
  width:1rem;
  height:1rem;
  position:fixed;
  z-index: 10;
  bottom: 3rem;
  right: 0.3rem;
  background-color: #fff;
  border-radius: 50%;

  img{
    width:100%;
    height:100%;
    border-radius: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/active/component/backTo.vue